import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BCMCLPUser, CLPUser, TeamCodes } from '../../../models/clpuser.model';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropDownFilterSettings, DropDownListComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { CMClubService } from '../../../services/cm-club.service';
import { CMClubResponse, CMSite, CMSiteEmployees, CMSiteEmployeesListResponse, CMSiteEmployeesUdtRequest, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { UserService } from '../../../services/user.service';
import { SimpleResponse, UserDD } from '../../../models/generic-response.model';
import { NotificationService } from '../../../services/notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { CMClub } from '../../../models/cm-general.model';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AfterViewInit } from '@angular/core';
import { merge, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { AppConfigService } from '../../../services/shared/app-config.service';
import { ConfigDetails } from '../../../models/app-config.model';
import { DatePipe } from '@angular/common';
import { CMContractItem, CMContractListRequest, CMContractLstResponse, eContractStatus } from '../../../models/cm-contract';
import { CMContractService } from '../../../services/cm-contract.service';
declare var $: any;

@Component({
    selector: 'app-lm-contract-list',
    templateUrl: './lm-contract-list.component.html',
    styleUrl: './lm-contract-list.component.css'
})
export class LmContractListComponent implements AfterViewInit, OnDestroy {
    @ViewChild("dropdownlist") public dropdownlist: DropDownListComponent;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<CMContractItem>;
    encryptedUser: string = '';
    user: BCMCLPUser;
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };
    sites: CMSite[];
    class1Code: number;
    club: CMClub;
    clpUsersDD: UserDD[];
    displayedColumns: string[] = ['position', 'Members', 'productDesc', 'status', 'dtCreated', 'dtContractStart', 'dtContractEnd', 'dtPaymentBegins', 'dteSig', 'fees'];
    submitted: boolean;
    curTeam: TeamCodes = <TeamCodes>{};
    curSite: CMSite = <CMSite>{};
    clubConfig: CMClub;
    showSpinner: boolean;
    selectedRowIndex: number = -1;
    curSiteSub: Subscription;
    clpCompanyId: number;

    selectedUserIDs = [];
    customFilter: boolean = false
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    selectedCtDtFilter: number = 1;
    customDateStr: string = '';
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCtDtFilterName: string;
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    allContractStatus = [
        {
            "value": 10,
            "name": "--All--"
        },
        {
            "value": 0,
            "name": "None"
        }, {
            "value": 1,
            "name": "Configured"
        }, {
            "value": 2,
            "name": "In Progress"
        }, {
            "value": 3,
            "name": "Members Signed"
        }, {
            "value": 4,
            "name": "On Hold Review"
        }
        , {
            "value": 5,
            "name": "Waiting Countersign"
        }
        , {
            "value": 6,
            "name": "Active"
        }, {
            "value": 7,
            "name": "In Active"
        }]
    timeFrames = [{
        "value": 1,
        "name": "Created"
    },
    {
        "value": 4,
        "name": "Payment Begins"
    },
    {
        "value": 5,
        "name": "Signed"
    },
    {
        "value": 6,
        "name": "Payment Collected"
    }]
    selectedConStatus: number = eContractStatus.All
    contractList: CMContractItem[];
    pageSize: number = 10;
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private fb: FormBuilder,
        private _router: Router,
        private clubService: CMClubService,
        private _utilityService: UtilityService,
        private notifyService: NotificationService,
        private userService: UserService,
        private _appconfigService: AppConfigService,
        private contractService: CMContractService,
        private datePipe: DatePipe
    ) {
        this.localService.setShowMenu(true)
        this.localService.setIsCmSite(true);
        this.localService.setRouteName("sm-contracts")
        this.loadPageSize()
    }

    loadPageSize() {
        const storedPageSize = localStorage.getItem('pageSize');
        if (storedPageSize) {
            this.pageSize = +storedPageSize;
        }
    }

    onPageChange(event: any) {
        localStorage.setItem('pageSize', event.pageSize);
    }

    ngOnInit() {
        
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {

                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }


    async loadData() {
        this.curTeam = JSON.parse(localStorage.getItem("curTeam") || '{}')
        await this.CMClub_Get()
        this.cLPUserGetListByTeamCode(this.clpCompanyId, this.curTeam?.teamCode)
        this.curSiteSub = this.clubService.curSite.pipe(takeUntil(this.destroy$)).subscribe(async (value: CMSite) => {
            this.curSite = await value
            if (this.curSite == null) {
                this.curSite = await JSON.parse(localStorage.getItem("curSite") || '{}')
            }
            this.siteSearch();

            this.cMContractGetList()
        })
    }

    private async authenticateR() {

        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectRow(row: any): void {
        if (row) {
            let url = "cm-contract/" + row?.contactID + '?r=' + this.encryptedUser
            window.open(url, '_blank')
            this.selectedRowIndex = row.sn;
        }
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        this.showSpinner = true
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--Select--"
                    })
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
        if (this.curSiteSub) {
            this.curSiteSub.unsubscribe()
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites
                        this.sites = this.sites.filter(item => item.siteID !== this.curSite?.siteID);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    createDtFilterChange(event): void {
        let value = event

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            this.cMContractGetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.cMContractGetList();
            }
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.cMContractGetList();
    }

    onValueChange(multiSelect: MultiSelectComponent) {
        multiSelect.clearFilter();
        this.cMContractGetList();
    }

    async cMContractGetList() {
        let cMContractListRequest = <CMContractListRequest>{}
        cMContractListRequest.timeFrame = this.selectedCtDtFilter
        cMContractListRequest.contractStatus = this.selectedConStatus
        cMContractListRequest.users = this.selectedUserIDs
        cMContractListRequest.sites = [this.curSite?.siteID]
        cMContractListRequest.strdtStart = this.selectedCustomdtStart
        cMContractListRequest.strdtEnd = this.selectedCustomdtEnd
        cMContractListRequest.clubId = this.clubConfig?.clubId
        this.showSpinner = true
        await this.contractService.cMContractGetList(this.encryptedUser, this.user?.cLPUserID, cMContractListRequest).
            then(async (result: CMContractLstResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contractList = response?.contractList
                    this.dataSource = new MatTableDataSource(this.contractList);
                    this.addTimeout(() => {
                        this.dataSource.paginator = this.paginator;
                    }, 1000)
                    this.dataSource.sort = this.sort;

                    this.dataSource.filterPredicate =
                        (data: CMContractItem, filter: string) => {
                            let values = filter.split(' ');

                            let finalValues: boolean[] = [];
                            let final: boolean = true;

                            values.forEach((value) => {
                                finalValues.push(data.cmContractID.toString().indexOf(value) != -1 ||
                                    data.contactName.trim().toLowerCase().indexOf(value) != -1 ||
                                    this.formatDate(data.dtCreated).toLowerCase().indexOf(value) != -1 ||
                                    this.formatDate(data.dtContractEnd).toLowerCase().indexOf(value) != -1 ||
                                    this.formatDate(data.dtContractStart).toLowerCase().indexOf(value) != -1 ||
                                    this.formatDate(data.dteSig).toLowerCase().indexOf(value) != -1 ||
                                    this.formatDate(data.dtPaymentBegins).toLowerCase().indexOf(value) != -1 ||
                                    data.fees.trim().toLowerCase().indexOf(value) != -1 ||
                                    this.formatMems(data.Members).trim().toLowerCase().indexOf(value) != -1 ||
                                    data.siteName.trim().toLowerCase().indexOf(value) != -1 ||
                                    data.status.trim().toLowerCase().indexOf(value) != -1
                                );
                            });

                            //only return if all values are true
                            finalValues.forEach(f => {
                                if (!f)
                                    final = false;
                            });

                            return final;
                        };
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.dataSource) {
            this.dataSource.filter = filterValue;
        }
    }

    formatMems(members) {
        let primaryMem = '';
        let otherMems = '';
        members.forEach((mem: string) => {
            if (mem?.includes('True')) {
                primaryMem = mem?.split(':')[0];
            }
            else {
                otherMems = `${otherMems}<div class='members-other'>${mem?.split(':')[0]}</div>`;
            }

        })
        return primaryMem ? `<div>${primaryMem}</div>  ${otherMems}` : '';
    }

    formatDate(dateString) {
        if (dateString != '') {
            const date = new Date(dateString);
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

            return formattedDate;
        }
        else return '';
    }

    getDate(value) {
        if (value == '0001-01-01T00:00:00') {
            return '';
        }
        else
            return value;
    }

    onTimeFrameChange() {
        this.selectedCustomdtStart = ''
        this.selectedCustomdtEnd = ''
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        if (this.selectedCtDtFilter == 1) {
            this.cMContractGetList();
        }
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
